/* One registration offer per order. Shopify remains the source of cart totals. */
(function () {
  'use strict';
  if (window.KD_COUPON) return;
  var key = 'kokochi-newsletter-offer-v2', code = 'KOKOCHI4000', entryKey = 'kokochi-entry-offer-shown-v1';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var eligible = false, applied = false, pending = null, lastFocus = null;
  try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {}
  function notify(value) {
    applied = value;
    document.dispatchEvent(new CustomEvent('kd:offer-state', { detail: { applied: applied } }));
  }
  function remember() { eligible = true; try { localStorage.setItem(key, 'yes'); } catch (_) {} }
  function check(cart) {
    var target = cart.items.filter(function (item) { return Number(item.product_id) === 9283999465610; });
    var usable = (cart.discount_codes || []).some(function (entry) { return entry.code.toUpperCase() === code && entry.applicable; });
    var expected = target.length ? 400000 : 0;
    if ((target.length && !usable) || cart.total_discount !== expected || cart.total_price !== cart.original_total_price - expected) throw Error('Offer total did not match');
    return cart;
  }
  async function apply() {
    if (!eligible) return null;
    if (pending) return pending;
    pending = (async function () {
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      });
      if (!response.ok) throw Error('Offer could not be applied');
      var cart = check(await response.json()); notify(true); return cart;
    })();
    try { return await pending; } catch (error) { notify(false); throw error; } finally { pending = null; }
  }
  function closePopups() {
    document.querySelectorAll('.sign-up-popup-modal,.success-popup-modal').forEach(function (node) { node.classList.remove('popup-modal--active'); });
    document.querySelectorAll('.sign-up-popup-overlay,.success-popup-overlay').forEach(function (node) { node.classList.remove('popup-overlay--active'); });
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  function openPopup(success) {
    lastFocus = document.activeElement;
    closePopups();
    var modal = document.querySelector(success ? '.success-popup-modal' : '.sign-up-popup-modal');
    var overlay = document.querySelector(success ? '.success-popup-overlay' : '.sign-up-popup-overlay');
    if (!modal || !overlay) return;
    modal.classList.add('popup-modal--active'); overlay.classList.add('popup-overlay--active');
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', success ? '登録特典' : 'メール登録で4,000円OFF');
    var focus = modal.querySelector(success ? 'button' : 'input[type=email]');
    if (focus) focus.focus({ preventScroll: true });
  }
  function status(message) {
    var node = document.querySelector('.success-popup-modal .popup-modal__success-msg');
    if (node) { node.textContent = message; node.style.display = 'block'; node.setAttribute('role', 'status'); }
  }
  async function signupSuccess() {
    remember();
    try { localStorage.setItem('promo-bar-subscribed-' + location.host, JSON.stringify({ subscribed: true })); } catch (_) {}
    openPopup(true); status('登録が完了しました。特典を適用しています…');
    var button = document.querySelector('.success-popup-modal .popup-modal__copy-btn');
    if (button) button.disabled = true;
    try {
      var cart = await apply();
      if (window.KD_CART_SYNC) await window.KD_CART_SYNC.refresh(cart);
      status(cart.items.length ? 'この注文に4,000円OFFを適用しました。' : '商品をカートに追加すると、4,000円OFFが適用されます。');
      if (button) button.textContent = '買い物を続ける';
    } catch (_) { status('特典を適用できませんでした。下のボタンから再試行できます。'); if (button) button.textContent = 'もう一度適用する'; }
    finally { if (button) button.disabled = false; }
  }
  function showError(form) {
    var target = form || document.querySelector('cart-drawer'); if (!target) return;
    var message = target.querySelector('.kd-offer-error');
    if (!message) { message = document.createElement('p'); message.className = 'kd-offer-error'; message.setAttribute('role', 'alert'); target.appendChild(message); }
    message.textContent = '登録特典を適用できませんでした。再試行するか、通常価格で購入できます。';
    if (target.querySelector('.kd-offer-fallback')) return;
    var button = document.createElement('button'); button.type = 'button'; button.className = 'button button--secondary kd-offer-fallback'; button.textContent = '特典を使わず通常価格で購入する'; target.appendChild(button);
    button.addEventListener('click', async function () {
      button.disabled = true;
      try {
        var response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) });
        if (!response.ok) throw Error('Could not remove offer');
        var cart = await response.json(); if (cart.total_discount !== 0) throw Error('Discount remains');
        eligible = false; try { localStorage.removeItem(key); } catch (_) {} notify(false); location.href = root + 'checkout';
      } catch (_) { message.textContent = '購入手続きに進めませんでした。もう一度お試しください。'; }
      finally { button.disabled = false; }
    });
  }
  window.KD_COUPON = { apply: apply, remember: remember, signupSuccess: signupSuccess, isApplied: function () { return applied; }, isEligible: function () { return eligible; } };
  var registering = new WeakSet();
  document.addEventListener('submit', async function (event) {
    var form = event.target, button = event.submitter;
    if (form.matches('.newsletter-form') && form.querySelector('[name="contact[email]"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!form.reportValidity() || registering.has(form)) return;
      registering.add(form); if (button) button.disabled = true;
      var error = form.querySelector('.kd-signup-error'); if (error) error.remove();
      try {
        var response = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
        if (!response.ok) throw Error('登録できませんでした。時間をおいてもう一度お試しください。');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!doc.querySelector('[data-kd-newsletter-success]')) {
          if (new URL(response.url).pathname.includes('/challenge') || doc.querySelector('form[action*="challenge"]')) { location.href = response.url; return; }
          var nativeError = doc.querySelector('.newsletter-form .form__message,.newsletter-form .errors');
          throw Error(nativeError ? nativeError.textContent.trim() : '登録を確認できませんでした。もう一度お試しください。');
        }
        await signupSuccess();
      } catch (failure) {
        error = document.createElement('p'); error.className = 'kd-signup-error'; error.setAttribute('role', 'alert'); error.textContent = failure.message; form.appendChild(error);
      } finally { registering.delete(form); if (button) button.disabled = false; }
      return;
    }
    if (!eligible || !button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); button.disabled = true;
    try { await apply(); location.href = root + 'checkout'; }
    catch (_) { button.disabled = false; showError(form); }
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('button,a,.popup-overlay'); if (!target) return;
    if (target.matches('.kd-offer-reopen')) { event.preventDefault(); openPopup(eligible); if (eligible) status(applied ? 'この注文に4,000円OFFを適用できます。' : '下のボタンから登録特典を適用できます。'); return; }
    if (target.matches('.popup-modal__close,.popup-modal__dismiss-btn,.sign-up-popup-overlay,.success-popup-overlay')) { closePopups(); return; }
    if (target.matches('.success-popup-modal .popup-modal__copy-btn')) { event.preventDefault(); if (applied) closePopups(); else signupSuccess(); return; }
    if (!eligible || !target.matches('a[href]') || new URL(target.href).pathname !== '/checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); apply().then(function () { location.href = target.href; }).catch(function () { showError(); });
  }, true);
  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('.popup-modal--active'); if (!modal) return;
    if (event.key === 'Escape') { closePopups(); return; }
    if (event.key !== 'Tab') return;
    var nodes = [].filter.call(modal.querySelectorAll('button,input,a[href]'), function (n) { return !n.disabled && n.offsetParent !== null; });
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function syncReopen() {
    var signup = document.querySelector('.sign-up-popup-modal');
    if(eligible && signup && signup.classList.contains('popup-modal--active')) { signup.classList.remove('popup-modal--active'); var overlay = document.querySelector('.sign-up-popup-overlay'); if(overlay) overlay.classList.remove('popup-overlay--active'); }

    var trigger = document.querySelector('.kd-offer-reopen');
    var active = document.querySelector('.sign-up-popup-modal.popup-modal--active,.success-popup-modal.popup-modal--active');
    if (trigger) {
      trigger.setAttribute('aria-expanded', String(!!active));
      if (active) { if (!active.id) active.id = active.matches('.success-popup-modal') ? 'kd-offer-success' : 'kd-offer-signup'; trigger.setAttribute('aria-controls', active.id); }
    }
  }
  function entryOffer() {
    if(eligible || !document.querySelector('.sign-up-popup-modal')) return;
    try { if(sessionStorage.getItem(entryKey)==='yes') return; sessionStorage.setItem(entryKey,'yes'); } catch(_) {}
    openPopup(false);
  }
  function ready() {
    var shell = document.querySelector('.kd-promo-shell');
    try {
      var previousSignup = JSON.parse(localStorage.getItem('promo-bar-subscribed-' + location.host) || 'null');
      if(previousSignup && previousSignup.subscribed === true) remember();
    } catch(_) {}
    if(shell && shell.dataset.kdNewsletterRegistered === 'true') remember();
    document.querySelectorAll('.sign-up-popup-modal,.success-popup-modal').forEach(function(modal){ new MutationObserver(syncReopen).observe(modal, { attributes:true, attributeFilter:['class'] }); });
    syncReopen();
    if(document.querySelector('[data-kd-newsletter-success]')) { signupSuccess(); return; }
    if(eligible) apply().then(function(cart){ if(window.KD_CART_SYNC) return window.KD_CART_SYNC.refresh(cart); }).catch(function(){});
    else entryOffer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
